import { Check, Feather, Music2 } from 'lucide-react'
import { useState } from 'react'
import { useApp } from '../state/AppContext'

export function ScorePage() {
  const { journey, reflect, busy } = useApp()
  const [text, setText] = useState(journey?.reflection || '')
  const [saved, setSaved] = useState(false)
  if (!journey) return <div className="page-loader">Abrindo sua partitura…</div>
  const complete = journey.activities.filter((activity) => activity.status === 'completed').length

  const save = async () => { try { await reflect(text); setSaved(true); window.setTimeout(() => setSaved(false), 1800) } catch { /* contexto */ } }

  return <div className="score-page">
    <header className="page-heading"><div><p>Sua partitura</p><h1>O que ficou<br /><em>em você?</em></h1></div><Feather /></header>
    <section className="score-sheet">
      <div className="score-sheet__top"><span>CICLO 01</span><span>{journey.work.year}</span></div>
      <p>{journey.work.composer}</p><h2>{journey.work.title}</h2><small>{journey.work.subtitle}</small>
      <div className="score-staves">{[0, 1, 2, 3, 4].map((line) => <i key={line} />)}<Music2 /></div>
      <div className="score-stats"><div><b>{complete}</b><span>encontros</span></div><div><b>{complete === 3 ? '1' : '0'}</b><span>obra vivida</span></div><div><b>7</b><span>dias</span></div></div>
    </section>
    <section className="diary"><p className="step-label">Diário de escuta</p><h2>O que essa escuta trouxe para você?</h2><p>Anote uma lembrança, uma imagem ou uma pergunta que esta obra deixou.</p><textarea rows={8} value={text} onChange={(event) => { setText(event.target.value); setSaved(false) }} placeholder="Quando penso nessa obra…" /><button className="button button--primary" onClick={save} disabled={busy || !text.trim()}>{saved ? <><Check />Guardado</> : busy ? 'Guardando…' : 'Guardar na partitura'}</button>
    </section>
    <section className="collection-preview"><div><p className="step-label">Sua coleção começa aqui</p><h2>1 obra</h2></div><div className="record-disc"><span>V</span></div></section>
  </div>
}
